"use strict";

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "objectToReactElement", {
  enumerable: true,
  get: function get() {
    return _objectToReact.objectToReactElement;
  }
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _objectToReact = require("./object-to-react"); // Provide object-to-react as an available helper on the library


var VDOM = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(VDOM, _React$Component);

  function VDOM() {
    (0, _classCallCheck2["default"])(this, VDOM);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VDOM).apply(this, arguments));
  }

  (0, _createClass2["default"])(VDOM, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.data !== this.props.data;
    }
  }, {
    key: "render",
    value: function render() {
      try {
        // objectToReactElement is mutatitve so we'll clone our object
        var obj = (0, _lodash.cloneDeep)(this.props.data);
        return (0, _objectToReact.objectToReactElement)(obj);
      } catch (err) {
        return React.createElement(React.Fragment, null, React.createElement("pre", {
          style: {
            backgroundColor: "ghostwhite",
            color: "black",
            fontWeight: "600",
            display: "block",
            padding: "10px",
            marginBottom: "20px"
          }
        }, "There was an error rendering VDOM data from the kernel or notebook"), React.createElement("code", null, err.toString()));
      }
    }
  }]);
  return VDOM;
}(React.Component);

exports["default"] = VDOM;
(0, _defineProperty2["default"])(VDOM, "MIMETYPE", "application/vdom.v1+json");